import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../store';

export enum AppLoadState {
  Loading = 'LOADING',
  Loaded = 'LOADED',
}

export interface IAppState {
  loadState: AppLoadState;
}

export interface TAppMetadata {
  numEntitlements: number;
}

// Side Effects
// ============
// https://redux.js.org/faq/actions#how-can-i-represent-side-effects-such-as-ajax-calls-why-do-we-need-things-like-action-creators-thunks-and-middleware-to-do-async-behavior

export const appLoaded = createAsyncThunk<
  void,
  TAppMetadata,
  {
    rejectValue: Error;
    state: RootState;
  }
>('appConfig/fetchAndLoadConfig', async (metadata, { getState, dispatch }) => {
  if (selectAppLoadState(getState()) === AppLoadState.Loaded) {
    // this is often blindly called by pages to finish an app load, shortcut out if already loaded
    return;
  }
  dispatch(setAppLoaded());
});

export const initialState: IAppState = {
  loadState: AppLoadState.Loading,
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setAppLoaded: (state) => {
      state.loadState = AppLoadState.Loaded;
    },
  },
});

export const { setAppLoaded } = appSlice.actions;

export const selectAppLoadState = (state: RootState) => state.app.loadState;

export default appSlice.reducer;
